import type { FC, SVGProps } from 'react';

export const BedIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="20"
    height="20"
    fill="currentColor"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fill="currentColor"
      d="M17.4998 8.33341V4.16675H2.49984V8.33341H1.6665V15.8334H3.33317V14.1667H16.6665V15.8334H18.3332V8.33341H17.4998ZM10.8332 5.83341H15.8332V8.33341H10.8332V5.83341ZM4.1665 8.33341V5.83341H9.1665V8.33341H4.1665ZM3.33317 12.5001V10.0001H16.6665V12.5001H3.33317Z"
    />
  </svg>
);
